import { GameGrid } from './GameGrid';
import { GridArray } from './GridArray';
import { Bubble } from './Bubble';

export class BubbleFactory {
  private grid: GameGrid;
  private gridArray: GridArray;
  private freeBubbles: Bubble[] = [];

  constructor(grid: GameGrid) {
    this.grid = grid;
    this.gridArray = grid.gridArray;
  }

  private getFreeBubble(): Bubble {
    if (this.freeBubbles.length > 0) return this.freeBubbles.pop() as Bubble;
    const bubble = new Bubble(this.grid);
    bubble.events.onKilled.add(() => {
      if (bubble.parent && bubble.parent.removeChild) {
        bubble.parent.removeChild(bubble);
        this.freeBubbles.push(bubble);
      }
    });
    return bubble;
  }

  public makeBubble(cellX: number, cellY: number, type: number): Bubble {
    const pxPos = this.grid.cellToInsidePx(cellX, cellY);
    const freeBubble = this.getFreeBubble();
    freeBubble.initRegular(cellX, cellY, pxPos[0], pxPos[1], type);
    this.gridArray.set(cellX, cellY, freeBubble);
    this.grid.add(freeBubble);
    return freeBubble;
  }
}